import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { PageHeader } from '../../components/common/PageHeader/PageHeader';
import { CMTableList } from '../../components/common/TableList/TableList';
import { PageRoutes } from '../../constants';
import { AppContext } from '../../components/common/Helpers/Context/AppContext';
import { deletePatient, deletePatientHard, getPatientlist, rollbackPatient } from './PatientServices';
import BookingModelBody from '../../components/common/Model/BookingModelBody';
import CMModelBody from '../../components/common/Model/ModelBody';

const PatientList = () => {

    const { globalData, setGlobalData } = React.useContext(AppContext);

    const columns: readonly any[] = [
        { key: "id", label: "ID", minWidth: 170 },
        { key: "name", label: "Patient Name", minWidth: 170 },
        { key: "father_or_mother_name", label: "Father / Mother Name", minWidth: 200 },
        { key: "aadhar_number", label: "Aadhar Number", minWidth: 170 },
        { key: "contact_number", label: "Contact Number", minWidth: 170 },
        { key: "height", label: "Height", minWidth: 170 },
        { key: "gender", label: "Gender", minWidth: 170 },
    ];

   

    React.useEffect(() => {
        setGlobalData({
            ...globalData,
            loading: true
        })
        getPatientlist().then((res: any) => {
            setGlobalData({
                ...globalData,
                loading: false
            })
        }).catch((err: any) => {
            console.log(err)
            setGlobalData({
                ...globalData,
                loading: false,
                error: true,
                errorMessage: "Failed to load data"
            });
        })
    }, [])
    
    const handleModelOpen = () => {
        return 
    }
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>

                    <Row>
                        <Col lg={12}>
                            <PageHeader header='Patients' list={true} link={PageRoutes.PATIENT_ADD} value={"Add Patient"}/>
                            <CMTableList
                                HideAction={false}
                                listService={getPatientlist}
                                deleteService={deletePatient}
                                deleteHardService={deletePatientHard}
                                rollbackSerivce={rollbackPatient}
                                showView={false}
                                showBlock={false}
                                editLink={PageRoutes.PATIENT_EDIT}
                                columns={columns}
                                deleteAccess={true}
                                editAccess={true}
                                noswitch={true}
                                // modelCmpnt={CMModelBody}
                                // isPatients={true}
                                ViewHeader="Update Patient"
                            />
                        </Col>
                    </Row>

                </Container>
            </div>
        </React.Fragment>
    );
};

export default PatientList;
